export default __webpack_public_path__ + "static/media/play-button.48fc7e6c.svg";